import { Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/InfoOutlined";

type Props = {
    title: string;
    size?: number;
};

const InfoBubble = ({ title, size = 18 }: Props) => {
    return (
        <Tooltip title={title}>
            <InfoIcon sx={{ fontSize: size }} />
        </Tooltip>
    );
};

export default InfoBubble;
